<script setup>
  import { ref, computed, defineAsyncComponent } from 'vue';

  import { useMediaQuery } from '@/composables/useMediaQuery';

  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';

  const ForecastTableContainer = defineAsyncComponent(() => import('@/components/ForecastTableContainer.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const zoomLevel = ref(1);
  const dailyMode = ref('basic');

  const minHeight = computed(() => {
    if (isDesktop.value) {
      if (zoomLevel.value === 7) return '400px';

      return dailyMode.value === 'basic' ? '450px' : '560px';
    };

    if (zoomLevel.value === 7) return '426px';

    return dailyMode.value === 'basic' ? '435px' : '545x';
  });

  const content = ref(null);

  const handleZoomLevelChange = (newZoom) => {
    zoomLevel.value = newZoom;
  }

  const handleDailyModeChange = (newMode) => {
    dailyMode.value = newMode;
  }
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="forecast-table"
      title="Forecast Table"
      containerTypeId="Model Table"
      containerTypeName="Forecast Table"
      :minHeight="minHeight"
    >
      <template #content="{ isVisible }">
        <ForecastTableContainer
          v-if="isVisible"
          @zoomLevel:change="handleZoomLevelChange($event)"
          @dailyMode:change="handleDailyModeChange($event)"
          v-model:content="content"
        />
      </template>
    </CompleteReportDataContainerSection>
</template>